import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { FavoritesService } from '../../services/favorites.service';
import { RestStopService } from '../../services/rest-stop.service';
import { RestStop } from '../../models/rest-stop';

@Component({
  selector: 'app-favorites-page',
  standalone: true,
  imports: [AsyncPipe, MatListModule, MatIconModule],
  templateUrl: './favorites.component.html',
  styleUrls: ['./favorites.component.scss'],
})
export class FavoritesComponent {
  private favoritesService = inject(FavoritesService);
  private restStopService = inject(RestStopService);
  private router = inject(Router);

  favoriteStops$: Observable<RestStop[]>;

  constructor() {
    this.favoriteStops$ = this.favoritesService.favorites$.pipe(
      switchMap((ids) => {
        if (ids.length === 0) {
          return of([]);
        }
        return this.restStopService.getRestStopsByIds(ids);
      }),
    );
  }

  showOnMap(stop: RestStop): void {
    this.router.navigate(['/', stop.slug]);
  }
}
